import "../css/index.scss";
import $ from "jquery/dist/jquery";

import "@nxcms/nxcms-js/src/js/sentry";

import "@nxcms/nxcms-js/src/js/static/bootstrap_5";
import "@nxcms/nxcms-js/src/js/static";
import "@nxcms/nxcms-js/src/js/blog";
import "@nxcms/nxcms-js/src/js/gallery";

// nxcms-js si tahá jen Modal a Collapse. Karusel a offcanvas menu
// doimportujeme sami — jinak by data-bs-* atributy nic nedělaly.
// Záměrně po jednom, ne celý bundle: Modal/Collapse by se registrovaly
// podruhé a data-api by se spouštělo dvakrát.
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/offcanvas";

import { mountVueApps } from "./apps";
import { initPwa } from "./pwa";
import { initNotifikace } from "./notifikace";

window.jQuery = window.$ = $;

mountVueApps();
initPwa();
initNotifikace();
